import { User } from 'lucide-react';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

export function Avatar({ src, alt = '', size = 'md', className = '' }: AvatarProps) {
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32',
  };

  const iconSizes = {
    sm: 'w-5 h-5',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16',
  };

  if (!src) {
    return (
      <div
        className={`
          ${sizes[size]} rounded-xl bg-neutral-200 
          flex items-center justify-center
          ${className}
        `}
      >
        <User className={`${iconSizes[size]} text-neutral-400`} />
      </div>
    );
  }

  return (
    <div className={`${sizes[size]} rounded-xl overflow-hidden ${className}`}>
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        onError={(e) => {
          // Hide broken image and show placeholder
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
        }}
      />
    </div>
  );
}
